/**
 * `/billing/mock-portal/$ref` — search schema.
 *
 * The mock processor has no hosted billing portal of its own (PAY-1 review round 3,
 * finding 1): `lib/payments/provider-mock.ts`'s `createPortalSession()` mints
 * `url: /billing/mock-portal/${customerRef}` — the same "honest local page instead of a
 * fabricated vendor URL" shape `createCheckout()` and `createAccountLink()` already use
 * (see `checkout.mock.$ref.tsx` and `connect.mock.$ref.tsx`, this route's siblings).
 * `POST /api/billing/subscription/portal` is not called from anywhere in this UI today
 * (there is no "Manage billing" button yet), so this route is unreachable in production
 * right now — it is built anyway, ahead of that button, so the day someone wires
 * `billingApi.subscriptionPortal()` to a click it lands on a real page instead of
 * reintroducing PAY-1's exact defect a third time.
 *
 * DELIBERATELY NOT UNDER `/settings` (same reasoning the other two mock-return pages give
 * for staying out of `/market`): the real portal `returnUrl` the gateway hands the
 * processor is `/settings/usage`, which IS gated on `VITE_BILLING` — but this page, the
 * one the mock processor sends the browser to BEFORE that return, needs no build flag to
 * render; it only says what it is and sends the subscriber back. Living directly under
 * `/billing`, a sibling of `/checkout` and `/connect` under the pathless `_authenticated`
 * layout, answers to no feature gate but being signed in.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/billing/mock-portal/$ref')({});
